
import React from "react";
import { indexTag } from "../../helpers";
import { useCountUp } from "../../hooks";
import styles from "../../assets/style.module.css";

export interface StatCardProps {
    index: number;
    value: number;
    label: string;
    start: boolean;
    prefix?: string;
    suffix?: string;
}

function StatCard({ index, value, label, start, prefix, suffix }: StatCardProps) {

    const count = useCountUp(value, start);

    return (<div className={styles["stat-card"]}>
        <span className={styles["tag"]}>{indexTag(index)}</span>
        <div className={styles["stat-bottom"]}>
            <span className={styles["h-04"]}>{prefix}{count}{suffix}</span>
            <span className={styles["stat-label"]}>{label}</span>
        </div>
    </div>);
}

export default StatCard;
